// extracted by mini-css-extract-plugin
module.exports = {"box":"gttl-guaranteed-rent_box__Lu_MP"};